// extracted by mini-css-extract-plugin
export var component = "TableModule-module--component--gLpD8";
export var head = "TableModule-module--head--xE1SP";
export var table = "TableModule-module--table--XPI2q";
export var td = "TableModule-module--td--KQVIs";
export var th = "TableModule-module--th--BQviZ";
export var title = "TableModule-module--title--nQPIF";